import { render, staticRenderFns } from "./gHead2.vue?vue&type=template&id=78fef582&scoped=true&"
import script from "./gHead2.vue?vue&type=script&lang=js&"
export * from "./gHead2.vue?vue&type=script&lang=js&"
import style0 from "./gHead2.vue?vue&type=style&index=0&id=78fef582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fef582",
  null
  
)

export default component.exports